import React, { Component } from 'react';

class FormFilterMejora extends Component {
    render() {
        const { formValues } = this.props;

        return (
            <div className="rk-wrap">
                <div className="rk-filter">
                    <div className="rk-filter__head">
                        <i className="fas fa-filter"></i> Filtrar riesgos
                    </div>

                    <div className="rk-filter__grid">
                        <div className="rk-field rk-filter__wide">
                            <label className="rk-label">Descripción del (Riesgo - Problema - Oportunidad)</label>
                            <input
                                type="text"
                                name="description"
                                onChange={this.props.HandleChangeFilter}
                                value={formValues.description}
                                className="rk-input"
                                placeholder="Buscar por descripción…"
                            />
                        </div>

                        <div className="rk-field">
                            <label className="rk-label">Tipo de riesgo</label>
                            <select name="risk_type" onChange={this.props.HandleChangeFilter}
                                value={formValues.risk_type} className="rk-input">
                                <option value="">Todos</option>
                                <option value="Riesgo">Riesgo</option>
                                <option value="Problema">Problema</option>
                                <option value="Oportunidad">Oportunidad</option>
                            </select>
                        </div>

                        <div className="rk-field">
                            <label className="rk-label">Cargo</label>
                            <select name="criterio_id" onChange={this.props.HandleChangeFilter}
                                value={formValues.criterio_id} className="rk-input">
                                <option value="">Todos</option>
                                {this.props.criterios.map(item => (
                                    <option key={item.id} value={item.id}>{item.name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="rk-field">
                            <label className="rk-label">Probabilidad</label>
                            <select name="probability" onChange={this.props.HandleChangeFilter}
                                value={formValues.probability} className="rk-input">
                                <option value="">Todas</option>
                                <option value="1">Improbable</option>
                                <option value="2">Remota</option>
                                <option value="3">Ocasional</option>
                                <option value="4">Probable</option>
                                <option value="5">Altamente Probable</option>
                            </select>
                        </div>

                        <div className="rk-field">
                            <label className="rk-label">Impacto</label>
                            <select name="impact" onChange={this.props.HandleChangeFilter}
                                value={formValues.impact} className="rk-input">
                                <option value="">Todos</option>
                                <option value="1">Insignificante</option>
                                <option value="2">Baja gravedad</option>
                                <option value="3">Grave</option>
                                <option value="4">Muy Grave</option>
                                <option value="5">Catastrófico</option>
                            </select>
                        </div>

                        <div className="rk-field">
                            <label className="rk-label">Área específica</label>
                            <select name="specific_area_id" onChange={this.props.HandleChangeFilter}
                                value={formValues.specific_area_id} className="rk-input">
                                <option value="">Todas</option>
                                {this.props.specific_areas.map(item => (
                                    <option key={item.id} value={item.id}>{item.name}</option>
                                ))}
                            </select>
                        </div>

                        <div className="rk-field">
                            <label className="rk-label">Actividad de riesgo</label>
                            <select name="activity_id" onChange={this.props.HandleChangeFilter}
                                value={formValues.activity_id} className="rk-input">
                                <option value="">Todas</option>
                                {this.props.activities.map(item => (
                                    <option key={item.id} value={item.id}>{item.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>

                    <div className="rk-filter__actions">
                        <button className="rk-btn rk-btn--ghost" onClick={() => this.props.showFilter()}>
                            Cancelar
                        </button>
                        <button className="rk-btn rk-btn--primary" onClick={() => this.props.HandleClickFilter()}>
                            <i className="fas fa-filter"></i> Aplicar filtro
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default FormFilterMejora;
